// #endregion
export var E_OperationType;
(function (E_OperationType) {
    E_OperationType["copy"] = "copy";
    E_OperationType["transfer"] = "transfer";
})(E_OperationType || (E_OperationType = {}));
export var E_TASK_TYPE;
(function (E_TASK_TYPE) {
    E_TASK_TYPE["ALL_TYPE"] = "ALL_TYPE";
    E_TASK_TYPE["PATENT_TYPE"] = "PATENT_TYPE";
    E_TASK_TYPE["SPACE_TYPE"] = "SPACE_TYPE";
    E_TASK_TYPE["FIELD_TYPE"] = "FIELD_TYPE";
    E_TASK_TYPE["COPY_PATENT_TO_LAYER"] = "COPY_PATENT_TO_LAYER";
    E_TASK_TYPE["BULK_EDIT"] = "BULK_EDIT";
    E_TASK_TYPE["FAMILY_EDIT"] = "FAMILY_EDIT";
    E_TASK_TYPE["AUTO_BULK_EDIT"] = "AUTO_BULK_EDIT";
    E_TASK_TYPE["FIELD_TRANSFORM_BULK_EDIT"] = "FIELD_TRANSFORM_BULK_EDIT";
    E_TASK_TYPE["AUTO_RULE_BULK_EDIT"] = "AUTO_RULE_BULK_EDIT";
    E_TASK_TYPE["UPDATE_READ_STATUS"] = "UPDATE_READ_STATUS";
    E_TASK_TYPE["CLONE_PATENT"] = "CLONE_PATENT";
    E_TASK_TYPE["HARD_DELETE_PATENT"] = "HARD_DELETE_PATENT";
    E_TASK_TYPE["ADD_PATENT"] = "ADD_PATENT";
    E_TASK_TYPE["DELETE_PATENT"] = "DELETE_PATENT";
    E_TASK_TYPE["COPY_PATENT"] = "COPY_PATENT";
    E_TASK_TYPE["MOVE_PATENT"] = "MOVE_PATENT";
    E_TASK_TYPE["COPY_FOLDER"] = "COPY_FOLDER";
    E_TASK_TYPE["MOVE_FOLDER"] = "MOVE_FOLDER";
    E_TASK_TYPE["DELETE_FOLDER"] = "DELETE_FOLDER";
    E_TASK_TYPE["DELETE_WORKSPACE_DATA"] = "DELETE_WORKSPACE_DATA";
    E_TASK_TYPE["ADD_WORKSPACE_DATA"] = "ADD_WORKSPACE_DATA";
    E_TASK_TYPE["CLONE_WORKSPACE_ALL_TYPE_DATA"] = "CLONE_WORKSPACE_ALL_TYPE_DATA";
    E_TASK_TYPE["UPDATE_WORKSPACE_ALL_TYPE_DATE"] = "UPDATE_WORKSPACE_ALL_TYPE_DATE";
    E_TASK_TYPE["SAVE_TO_WORKSPACE_DATA"] = "SAVE_TO_WORKSPACE_DATA";
    E_TASK_TYPE["UPDATE_WORKSPACE_DATA_READ_STATUS"] = "UPDATE_WORKSPACE_DATA_READ_STATUS";
    E_TASK_TYPE["TRANSFER_COPY_SPACE"] = "TRANSFER_COPY_SPACE";
    E_TASK_TYPE["BO_TRANSFER_COPY_SPACE"] = "BO_TRANSFER_COPY_SPACE";
    E_TASK_TYPE["CLEAN_DELETED_PATENT"] = "CLEAN_DELETED_PATENT";
    E_TASK_TYPE["SHARE_CUSTOM_FIELD"] = "SHARE_CUSTOM_FIELD";
    E_TASK_TYPE["USER_DELETE_LAYER_NODE"] = "USER_DELETE_LAYER_NODE";
    E_TASK_TYPE["USER_DELETE_LAYER_FIELD"] = "USER_DELETE_LAYER_FIELD";
    E_TASK_TYPE["USER_DELETE_LAYER_VALUE"] = "USER_DELETE_LAYER_VALUE";
})(E_TASK_TYPE || (E_TASK_TYPE = {}));
export var E_TASK_STATUS;
(function (E_TASK_STATUS) {
    /**
     * 所有状态
     */
    E_TASK_STATUS["ALL_STATUS"] = "ALL_STATUS";
    /**
     * 等待中
     */
    E_TASK_STATUS["READY_STATUS"] = "READY_STATUS";
    /**
     * 正在进行
     */
    E_TASK_STATUS["PROGRESSING_STATUS"] = "PROGRESSING_STATUS";
    /**
     * 已取消
     */
    E_TASK_STATUS["CANCELED_STATUS"] = "CANCELED_STATUS";
    /**
     * 已完成
     */
    E_TASK_STATUS["FINISHED_STATUS"] = "FINISHED_STATUS";
    /**
     * 错误
     */
    E_TASK_STATUS["FAILED_STATUS"] = "FAILED_STATUS";
    /**
     * 等待
     */
    E_TASK_STATUS["TATUS_READY"] = "000";
    /**
     * 跳过
     */
    E_TASK_STATUS["TATUS_SKIP"] = "100";
    /**
     * 异常
     */
    E_TASK_STATUS["TATUS_FAIL_EXCEPTION"] = "501";
    /**
     * IO错误
     */
    E_TASK_STATUS["TATUS_FAIL_IO_EXCEPTION"] = "502";
    /**
     * 超过重试次数
     */
    E_TASK_STATUS["TATUS_FAIL_RETRY_OVER_LIMIT"] = "503";
    /**
     * 处理中
     */
    E_TASK_STATUS["TATUS_PROCESSING"] = "300";
    /**
     * 成功
     */
    E_TASK_STATUS["TATUS_FINISH"] = "200";
    /**
     * 部分成功
     */
    E_TASK_STATUS["TATUS_FINISH_PART"] = "201";
    /**
     * 超时
     */
    E_TASK_STATUS["TATUS_TIMEOUT"] = "408";
    /**
     * 取消
     */
    E_TASK_STATUS["TATUS_CANCELED"] = "403";
})(E_TASK_STATUS || (E_TASK_STATUS = {}));
// #region Data Center
export var E_CHART_ID;
(function (E_CHART_ID) {
    // 任务处理趋势
    E_CHART_ID["TaskTrend"] = "TaskTrend";
    // 任务类型
    E_CHART_ID["TaskType"] = "TaskType";
    // 任务状态
    E_CHART_ID["TaskStatus"] = "TaskStatus";
    // 错误数最多的用户 Top 10
    E_CHART_ID["ErrorMaxTop"] = "ErrorMaxTop";
    // 任务数最多的用户 Top 10
    E_CHART_ID["TaskMaxTop"] = "TaskMaxTop";
})(E_CHART_ID || (E_CHART_ID = {}));
export var E_CHART_TYPE;
(function (E_CHART_TYPE) {
    // 柱状图
    E_CHART_TYPE["Bar"] = "bar";
    // 折线图
    E_CHART_TYPE["Line"] = "line";
    // 饼图
    E_CHART_TYPE["Pie"] = "pie";
    // 横向柱状图
    E_CHART_TYPE["HorizontalBar"] = "HorizontalBar";
    // 折柱混合图
    E_CHART_TYPE["BarLine"] = "bar+line";
    // 仪表盘
    E_CHART_TYPE["Gauge"] = "gauge";
})(E_CHART_TYPE || (E_CHART_TYPE = {}));
export const columns = [
    {
        label: 'backoffice.account.account',
        field: 'operate_email',
    },
    {
        label: 'workspace.taskCenter.type',
        field: 'type',
    },
    {
        label: 'workspace.taskCenter.status',
        field: 'status_code',
    },
    {
        label: 'workspace.taskCenter.creatAt',
        field: 'start_time',
    },
    {
        label: 'workspace.taskCenter.executionTime',
        field: 'spend_time',
    },
    {
        label: 'workspace.taskCenter.taskId',
        field: 'task_id',
    },
    {
        label: 'workspace.taskCenter.patentCount',
        field: 'patent_count',
    }
];
export var ERatioChart;
(function (ERatioChart) {
    ERatioChart["WorkspaceRatio"] = "WorkspaceRatio";
    ERatioChart["FolderRatio"] = "FolderRatio";
    ERatioChart["PatentRatio"] = "PatentRatio";
    ERatioChart["RedisMemoryRatio"] = "RedisMemoryRatio";
    ERatioChart["RedisCostRatio"] = "RedisCostRatio";
})(ERatioChart || (ERatioChart = {}));
export var EChartId;
(function (EChartId) {
    EChartId["Workspace"] = "Workspace";
    EChartId["Folder"] = "Folder";
    EChartId["Patent"] = "Patent";
    // RedisMemory = 'RedisMemory',
    // RedisCost = 'RedisCost',
})(EChartId || (EChartId = {}));
export var EDataChart;
(function (EDataChart) {
    EDataChart["WorkspaceTotalData"] = "WorkspaceTotalData";
    EDataChart["FolderTotalData"] = "FolderTotalData";
    EDataChart["PatentTotalData"] = "PatentTotalData";
    // RedisMemoryData = 'RedisMemoryData',
    // RedisCostData = 'RedisCostData',
})(EDataChart || (EDataChart = {}));
// #endregion
